import {getSiblings} from './utils';

const classNames = {
  sort: {
    itemVisible: `sort-panel__item--visible`,
    wrapExpanded: `sort-panel__wrap--expanded`
  }
};

export default (container, cb) => {
  const sortPanel = container.querySelector(`.sort-panel`);
  const sortPanelWrap = sortPanel.querySelector(`.sort-panel__wrap`);
  const toggleSortItems = (item) => {
    const siblings = getSiblings(item);
    const sortParam = item.dataset.sort;

    item.classList.add(classNames.sort.itemVisible);
    siblings.forEach(sibling => sibling.classList.remove(classNames.sort.itemVisible));
    sortPanelWrap.classList.remove(classNames.sort.wrapExpanded);
    cb(sortParam);
  };

  sortPanel.addEventListener(`click`, (e) => {
    if (e.target === e.currentTarget) {
      sortPanelWrap.classList.toggle(classNames.sort.wrapExpanded);
      return;
    }
    toggleSortItems(e.target);
  });
};
